module.exports = __webpack_public_path__ + "static/media/man-791049_1920.c13a5d5f.jpg";